<template>
  <div>
    <div class="container">
      <div class="pt-20 text-center">
        <h2 class="text-4xl md:text-6xl font-serif text-gradient">Reach out to me</h2>
        <p class="text-md md:text-lg text-gray-10 w-full md:w-9/12 mt-8 md:mt-0 mx-auto">
          Rich experience in Web Development/Designing &amp; building/maintaining and advanced customization. I am good at HTML, CSS, javascript, WordPress, PHP, jquery, bootstrap, Angularjs, Vue js, react js Developer, effects &amp; Animation. I love to discuss your unique ideas and share my reviews with a cup of coffee. Feel free to contact me anytime by writing an email about your project idea.
        </p>
        <div class="mt-10 text-center">
          <a class="btn" href="tel:+918506817383">Connect Me</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "Contact",

};
</script>
<style lang="postcss"></style>